// https://www.npmjs.com/package/react-device-detect
// https://github.com/duskload/react-device-detect/blob/HEAD/docs/selectors.md

import * as deviceInfo from 'react-device-detect';

/*
    isBrowser
    isMobile
    isTablet
    isIE
    browserName
    isAndroid
    isIOS
    isWinPhone
    isChrome
	isFirefox
	isSafari
	isOpera
	isIE
	isEdge
	isChromium
	isMobileSafari
	isSamsungBrowser
	osVersion
	osName
	fullBrowserVersion
	mobileVendor
	mobileModel
	engineName
	engineVersion
	getUA
	isWindows
	isMacOs
	deviceDetect => "{\"deviceDetect\":{\"isBrowser\":true,\"browserMajorVersion\":\"130\",\"browserFullVersion\":\"130.0.0.0\",\"browserName\":\"Chrome\",\"engineName\":\"Blink\",\"engineVersion\":\"130.0.0.0\",\"osName\":\"Linux\",\"osVersion\":\"x86_64\",\"userAgent\":\"Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/130.0.0.0 Safari/537.36\"}}"
*/
export const getDeviceInfo = () => {

	var deviceDetect = localStorage.getItem("device");

	// get info only if not there yet
	if(!deviceDetect || deviceDetect.length === 0){
		deviceDetect = JSON.stringify(deviceInfo.deviceDetect());
		localStorage.setItem("device",deviceDetect); 
	}

	return JSON.parse(deviceDetect);
}

export const isIOS = () => {
	return deviceInfo.isIOS;
};

export const isIPad = () => {
	// iPad on iPadOS 13+ is detected as 'Macintosh' but with touchPoints
	const isIPadOS = navigator.maxTouchPoints > 1 && /Macintosh/.test(navigator.userAgent);
	return deviceInfo.isIPad13 || isIPadOS;
};

export const isMobile = () => {
	return deviceInfo.isMobile;
};

export const isTablet = () => {
	return deviceInfo.isTablet;
};

export const isDesktop = () => {
	return !deviceInfo.isMobile && !deviceInfo.isTablet;
};

export const getDeviceFriendlyName = () => {
	const info = deviceInfo.deviceDetect();
	const os = info.osName;
	const browser = info.browserName;
	return `${browser} (${os})`;
}